@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.login

import com.narbase.letsgo.router.EndPoint


object AdminLoginEndpoint : EndPoint<AdminLoginEndpoint.Request, AdminLoginEndpoint.Response>() {
    class Request

    class Response(
        val data: String? = null,
    )
}

